'use client';
import React, { useEffect } from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import { LayoutProps } from './layout.props';
import getFromCookie from '@utils/cookies/get-from-cookie';
import { AuthActions } from '@store/auth/auth-actions';
import { BasketActions } from '@store/basket/basket-actions';
import { useDispatch } from 'react-redux';
import Footer from '@layouts/footer';
import Header from '@layouts/header';
import WorkHoursModal from '@layouts/work-hours-modal';
import { HomeActions } from '@store/home-screen/home-action';
import { useRouter } from '@bprogress/next';

const Layout = ({ children }: LayoutProps) => {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    dispatch(HomeActions.setNavigation({ navigation: router }));
    const token = getFromCookie('token');
    if (!!token) {
      dispatch(AuthActions.getClientInfo({ token: token }));
      dispatch(BasketActions.getBasketInfo());
    }
  }, []);

  return (
    <Div className={'flex-col'}>
      <Header/>
      <Div className={'flex-col'}>
        {children}
        <Footer/>
      </Div>
      <WorkHoursModal/>
    </Div>
  );
};

export default Layout;
